<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.index(v-if='!loading')
        .grid
          .col-12
            h2.category(:style="textColor")
              | {{ title }}
          .col-12.hero-row
            visual.hero(:image="hero" background="cover" role="img" :aria-label="heroAlt")
          .col-8_xs-12(data-push-left="off-4_xs-0")
            .copy.wysiwyg(v-html="content.main_text")
            .grid.no-margin
              .col-6_xs-12(v-for="child in children")
                .page
                  router-link(:to="route(child.uid)")
                    .captions-mobile
                      h2.subpage
                        | {{ child.content.title.toLowerCase() }}
                    .screen-small(:style="backgroundColor")
                      visual(
                        :image="pageHero(child.content.main_image, child.files)"
                        background="cover"
                        v-if="pageHero(child.content.main_image, child.files)"
                        role="img"
                        :aria-label="child.content.title.toLowerCase()"
                      )
                      .imageless(v-if="!pageHero(child.content.main_image, child.files)")
                      .captions(:class="{ gradient: pageHero(child.content.main_image, child.files)}")
                        h2.subpage
                          | {{ child.content.title.toLowerCase() }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'generic-index',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.requestData(this.$route.name)
  },

  methods: {
    pageHero: function (name, files) {
      if (name.length > 0) {
        return files.find(item => item.filename === name)
      } else {
        return false
      }
    },

    route: function (uid) {
      const page = {name: this.$route.name + '-page', params: { id: uid }}
      const blog = {name: 'blog'}
      return uid === '600state' ? blog : page
    }
  },

  computed: {
    title: function () {
      return this.content.title.toLowerCase()
    },

    content: function () {
      return this.loadedData[this.$route.name].content
    },

    key: function () {
      return this.$route.name
    },

    files: function () {
      return this.loadedData[this.$route.name].files
    },

    children: function () {
      return this.loadedData[this.$route.name].children
    },

    hero: function () {
      const name = this.content.main_image
      return this.files.find(item => item.filename === name)
    },

    heroAlt: function () {
      console.log(this.hero)
      return this.hero.meta.caption
    },

    textColor: function () {
      return 'color: ' + this.colors[this.$route.name]
    },

    backgroundColor: function () {
      return 'background-color: ' + this.colors[this.$route.name]
    }

  },

  watch: {
    '$route' (to, from) {
      this.requestData(to.name)
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .index
    @include respond-to(xs)
      padding-top: 1rem
    .hero-row
      padding-bottom: 0
    .hero
      .vv-image
        width: 100%
        height: 76.5vH
        background-size: cover
        background-repeat: none
        @include respond-to(xs)
          height: 0
          padding-bottom: 58%
    .category
      @include respond-to(xs)
        font-size: 2.5rem
        font-weight: 700
    .copy
      margin-bottom: 6rem
      margin-top: 6rem
    .screen-small
      width: 100%
      height: 0
      padding-bottom: 100%
      @include respond-to(xs)
        padding-bottom: 0%
        height: unset
      position: relative
      .vv-image
        width: 100%
        height: 0
        padding-bottom: 100%
        background-size: cover
        background-repeat: none
        @include respond-to(xs)
          padding-bottom: 52%
      .imageless
        display: none
        width: 100%
        height: 0
        padding-bottom: 52%
        @include respond-to(xs)
          display: block
      .captions, .captions-mobile
        width: 100%
        height: 40%
        opacity: 1
        color: white
        position: absolute
        bottom: 0
        &.gradient
          background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
        h2
          position: absolute
          bottom: 0
          font-size: 4rem
          padding-left: 3.3rem
          padding-right: 3.3rem
          padding-bottom: 3.3rem
          letter-spacing: $kerningMidTight
      .captions
        @include respond-to(xs)
          display: none
    .captions-mobile
      display: none
      @include respond-to(xs)
        display: block
</style>



// WEBPACK FOOTER //
// GenericIndex.vue?09cebdf2